import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  requestUpdateUserGroups,
  requestViewStaff,
  requestPopulateDropdowns,
} from '../../../api/admin/user-role/admin-user-role.actions';

import { setInitialFilters } from '../../../slices/admin/user-role-management/user-role-management.slice';

import UserRoleManagement from '../../../components/screens/admin/user-role-management/UserRoleManagement';

const UserRoleManagementContainer = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const { initialFilters, staff, members, usernames } = useSelector(({ userRoleManagement }) => userRoleManagement);

  const dispatch = useDispatch();

  const retrieveStaff = useCallback(
    (filters) => {
      dispatch(
        requestViewStaff({
          filters: {
            member: filters.member?.label,
            username: filters.username?.value,
            recordsPerPage: filters.recordsPerPage?.value,
            page: filters.page,
            admin: filters.admin,
            facilitator: filters.facilitator,
          },
          onSuccess: (totalStaff) => {
            setTotalPages(Math.ceil(totalStaff / filters.recordsPerPage.value));
            setCurrentPage(filters.page);
          },
        })
      );
      dispatch(setInitialFilters(filters));
    },
    [dispatch]
  );

  useEffect(() => {
    retrieveStaff(initialFilters);
    dispatch(requestPopulateDropdowns());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, retrieveStaff]);

  const updateRoles = (personExternalReference, roles, onSuccess) => {
    const input = {
      ...roles,
      personExternalReference,
    };

    dispatch(
      requestUpdateUserGroups({
        input,
        onSuccess: () => {
          retrieveStaff(initialFilters);
          onSuccess();
        },
      })
    );
  };

  return (
    <UserRoleManagement
      staff={staff}
      members={members}
      usernames={usernames}
      initialFilters={initialFilters}
      currentPage={currentPage}
      totalPages={totalPages}
      retrieveStaff={retrieveStaff}
      updateRoles={updateRoles}
    />
  );
};

export default UserRoleManagementContainer;
